// Configuration des URLs CSV

// Utilise Cloudflare Worker avec cache
const CLOUDFLARE_WORKER_URL = import.meta.env.VITE_CLOUDFLARE_WORKER_URL || 'https://pemlab.garciathomas.workers.dev';

// URLs via Cloudflare Worker
export const CSV_URL = `${CLOUDFLARE_WORKER_URL}/questions`;
export const QUESTIONS_META_URL = `${CLOUDFLARE_WORKER_URL}/questions-meta`;
export const BONUS_CSV_URL = `${CLOUDFLARE_WORKER_URL}/bonus`;
export const PRODUCTS_CSV_URL = `${CLOUDFLARE_WORKER_URL}/products`;

// Webhook URL pour les soumissions
export const WEBHOOK_URL = import.meta.env.VITE_WEBHOOK_URL || 
  'https://pemlab.app.n8n.cloud/webhook/questions';

// URL de base pour les redirections
export const REDIRECT_BASE_URL = 'https://pemlab-paris.fr/collections/all';

// Configuration API
export const API_CONFIG = {
  timeout: 30000, // 30 secondes
  retries: 3,
  retryDelay: 1000 // 1 seconde
};